console.log('test');

let monogramBtn = document.querySelector(".personalization-btn");
let monogramPopup = document.querySelector(".personalization-sec");
let monogramCloseBtn = document.querySelector(".monogram-save-close");
let warMessagePopup = document.querySelector(".close-validate-btn");
let bodyTag =  document.querySelector(".template-product");
let closeReset = document.querySelector(".close-reset");
let monoPersonalizeButton = document.querySelector(".personalization-btn");





var timesRun = 0;
var interval = setInterval(function(){ 
    var html_value = $('#infiniteoptions-container').html();
        timesRun += 1;
    if(html_value == ''){
        $('.personalization-btn').hide();
        if(timesRun === 80){
        clearInterval(interval);
        }
    }  
    else{
        $('.personalization-btn').css('display','block');
        clearInterval(interval);
    }
    
}, 500);



if(monogramBtn != null) {
monogramBtn.addEventListener('click', (event) => {
    monogramPopup.classList.add("activate-monogram");
    bodyTag.classList.add("fixed-body");
});
}
if(warMessagePopup != null) {
warMessagePopup.addEventListener('click', (event) => {
    $('.activate-monogram').removeClass('overlay');
    $('.warning-modal').prop("hidden", !this.checked);
});
}

if (closeReset != null) {
closeReset.addEventListener('click', (event) => {
    location.reload();
    monogramPopup.classList.remove("activate-monogram");
    bodyTag.classList.remove("fixed-body");
});
}
if (monogramCloseBtn != null) {
    monogramCloseBtn.addEventListener('click', (event) => {
        var monoText = $("input[name='properties[Monogram]']").val();
        let selected_value;
    
        $('input[name="properties[Color]"]').change(function(){
            console.log('test 123');
            selected_value = $("input[name='properties[Color]']:checked").val();
            console.log('selected_value', selected_value);
        });

        var monoPlacement = $("select[name='properties[Monogram Placement]']").val(); 
        selected_value = $('.spb-productoptionbackground:checked').val();
        console.log('selected_value', selected_value);

        if(monoText == ''|| monoText == null) {
            console.log('Monotext required');
            $(".war-text").text('Please Enter Monogram Text.')
            $('.warning-modal').removeAttr('hidden');
            
            $('.activate-monogram').addClass('overlay');
            return 0;
        } else if (selected_value == '' || selected_value == null) {
            $(".war-text").text('Please Select Monogram Color.')
            $('.warning-modal').removeAttr('hidden');

            $('.activate-monogram').addClass('overlay');
            return 0;
        } else if (monoPlacement == '' ||  monoPlacement == null) {
            console.log('monoPlacement required');
            $(".war-text").text('Please Select Monogram Placement Type.')
            $('.warning-modal').removeAttr('hidden');

            $('.activate-monogram').addClass('overlay');
            return 0;
        } 
        monogramPopup.classList.remove("activate-monogram");
        bodyTag.classList.remove("fixed-body");
    });
}

// all brandpop background scroll block class add

$('.allbrand-card').click(function() {
    $('.template-page').addClass('background-scroll-block');
});


$(document).bind('cbox_closed', function(){
setTimeout(
    $('.template-page').removeClass('background-scroll-block')
    , 1500);
});